import { Text } from 'rebass/styled-components'

export default ({ children, ...props }) => {
    return (
        <Text color="secondary" {...props} as="span">
            ${children}
        </Text>
    )
}
